<div class="dialog-wrapper">
  <div class="warning-header">
    <div class="header-left">
      <div class="icon-circle">
        <mat-icon>warning</mat-icon>
      </div>
      <div class="title-area">
        <h2 mat-dialog-title>
          {{ 'createDoc.failedDialog.title' | transloco }}
        </h2>
      </div>
    </div>
    <button mat-icon-button color="primary" (click)="onCancel()" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <p class="description-text">
      {{ 'createDoc.failedDialog.descriptionCountPrefix' | transloco }}
      <strong>
        {{ problemCount }}
        {{ 'createDoc.failedDialog.of' | transloco }}
        {{ data.totalCount }}
      </strong>
      {{ 'createDoc.failedDialog.descriptionText' | transloco }}
    </p>

    <h3 class="list-title">
      {{ 'createDoc.failedDialog.listTitle' | transloco }}
    </h3>

    <div class="problem-container">
      <div class="table-header">
        <span class="col-id">
          {{ 'createDoc.failedDialog.tableHeaderId' | transloco }}
        </span>
        <span class="col-status">
          {{ 'createDoc.failedDialog.tableHeaderStatus' | transloco }}
        </span>
      </div>
      <div class="table-body">
        <div *ngFor="let entry of data.problemEntries" class="table-row">
          <div class="col-id">
            <span class="id-badge">{{ entry.id }}</span>
          </div>
          <div class="col-status">
            <span class="status-indicator"></span>
            {{ getProblemLabel(entry.problemCode) }}
          </div>
          <div class="col-action">
            <a
              mat-button
              color="primary"
              [routerLink]="[data.isPackagingSystem ? '/cockpit/packaging/packaging-system/update' : '/cockpit/packaging/packaging-unit/update', entry.id]"
              target="_blank"
              class="open-tab-btn">
              <mat-icon>open_in_new</mat-icon>
              <span>{{ 'createDoc.failedDialog.openInNewTab' | transloco }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="summary-line">
      <strong>
        {{ problemCount }}
        {{ 'createDoc.failedDialog.of' | transloco }}
        {{ data.totalCount }}
      </strong>
      {{ 'createDoc.failedDialog.summaryWithoutTd' | transloco }}
      &nbsp;•&nbsp;
      <span class="valid-text">
        {{ validCount }}
        {{ 'createDoc.failedDialog.summaryComplete' | transloco }}
      </span>
    </div>

    <div class="info-note">
      <mat-icon>info</mat-icon>
      <span>{{ 'createDoc.failedDialog.infoNote' | transloco }}</span>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button mat-stroked-button (click)="onCancel()">
      {{ 'common.buttons.cancel' | transloco }}
    </button>
    <button mat-raised-button color="primary" (click)="onCreateAnyway()">
      {{ 'createDoc.failedDialog.createAnywayButton' | transloco }}
    </button>
  </mat-dialog-actions>
</div>
